module.exports = __webpack_public_path__ + "static/media/AI_3.c2d48db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_3.png
// module id = 118
// module chunks = 0